import { environment } from '../../../environments/environment';

export const CONFIGURATION: string = environment.configuration;
/** Url base del servidor */
export const BASE_HREF: string = environment.base_href;
/** Url base de la web */
export const BASE_WEB_HREF: string = environment.web_base_url;
/** Tiempo de simulación de búsqueda en servidor */
export const DELAY: number = environment.delay;
/** Url raíz a la API en el servidor */
export const SERVER_API_URL: string = environment.server_api_url;

/** Url raíz para la parte interna */
export const ROOT_INTERNA = "internal";
/** Url raíz para la parte externa */
export const ROOT_EXTERNA = "external";

/** Idioma en localstorage */
export const LS_LANG = 'carpetav2-lang';
/** Idioma por defecto: catalán */
export const DEFAULT_LANG = 'ca';
/** Idioma opcional */
export const OPTIONAL_LANG = 'es';

/** Status error Unauthorized */
export const UNAUTHORIZED = 401;
/** Status error Forbidden */
export const FORBIDDEN = 403;

/** RUTAS DE LOGIN */
export const STORAGE = {
  /** Id del  */
  VALID_ID: "valid_id",
  /** Certificado Valid */
  VALID_TOKEN: "valid_token",
  /** Usuario en localstorage */
  USUARIO: 'username',
  /** Fecha de acceso en localstorage */
  DATE: 'date',
  /** Token de acceso en localstorage */
  ACCESS_TOKEN: 'access_token',
  /** Token de refresco en localstorage */
  REFRESH_TOKEN: 'refresh_token',
  /** Fecha de del ultimo acceso en localstorage  */
  DATE_ANT: 'dateant',
  /** DBOId del tercero seleccionado */
  DBOID: 'dboid',
  /**Todos los roles parte interna */
  ALLROLS: 'allrols',
  /**Todos los roles parte interna */
  IDEMPRESA: 'idempresa',
  /**Ip del uaurio de acceso */
  IP: 'ipusuario',
  /**Ip del uaurio de acceso */
  TOKENWS: 'tokenws',
}

/** código de los diferentes web services externos */
export const CODE_WEBSERVICES = {
  DADESCONTACTE : 'WSPASPROVEIDORCONT',
  //INSTITUCIONS: 'WSPASINSTITUCIONS',
  //DADESPERSONALS: 'WSPASPROVEIDORAPERS',
  //HABITANT: 'WSPASHABITADADESWSI',
  //MAILSTONOTIFPADRO: 'WSENVIARPADROMAIL',
  //DADESBANCARIES: 'WSPASPROVEIDORBANK',
  REBUTSPENDENTS: 'WSPASREBUTSPENDENTSWSI',
  //PERSONADRESS: 'WSPASPERSONADRESWSI',
  //UNITATSFISCALBYIDNUMBER: 'WSPASUFISCALWSI',
  //IMPRESSOSSUBVENCIONS: 'WSIMPRESSOSSUBVENCIONS',
  //ISCORRENTPAGAMENTAJUNTAMENTPAS: 'WSISCORRENTPAGAMENTAJUNT',
  //EXPEDIENTSAJUDABYNIF: 'WSPASEXPEDIENTSAJUDA',
  //EXPEDIENTSBYNIF: 'WSPASEXPEDIENTS',
  //FACTURESPENDENTSINTERN: 'WSPASFACTURESPENDENTSINTERN',
  //FACTURESPENDENTS: 'WSPASFACTURESPENDENTS',
  //FACTURESAMBINCIDENCIES: 'WSPASFACTURESINCIDENCIES',
  //FACTURESCOBRADES: 'WSPASFACTURESCOBRADES',
  //MESAELECCIONSBYIDENT: 'WSMESAELECCIONS',
  NIOSDISPONIBLESPROV: 'WSNIOSDISPONIBLESPROV',
  //DADESBANCARIESDEFETCTESNP: 'WSPASPROVEIDORBANKDEFAULT',
  REBUTSCOBRATS: 'WSPASREBUTSCOBRATSWSI',
  //FACTURESCOBRADESINTERN: 'WSPASFACTURESCOBRADESINTERN',
  COMUNICACIONSBYNIF: 'WSENOTUMCOMWSI',
  NOTIFICACIONSBYNIF: 'WSENOTUMNOTWSI',
  QUEIXESBYNIF: 'WSPASQUEIXESWSI',
  TRAMITSPORTALCIUTADA: 'WSTRAMITSCARPETACIUT',
  TRAMITSPORTALPROVEIDOR: 'WSTRAMITSCARPETAPROV',
  TRAMITSPORTALEMPRESA: 'WSTRAMITSCARPETAEMPR',
  ACCESTOTSTRAMITS: 'WSPASTOTSTRAMITSTEL',
  ESBORRANYSTRAMITS: 'WSESBORRANYSTRAMITS',
  //INPUTANNOTATIONSBYPERSON: 'WSPASREGISTREDADESWSI',
  //OUTPUTANNOTATIONSBYPERSON: 'WSPASREGSORTIDADADESWSI',
  //REBUTSEXECUTIVA: 'WSPASREBUTSEXECWSI',
  //FIANCES: 'WSIFIANCES',
  //FACTURESAMBINCIDENCIESINTERN: 'WSPASFACTURESINCIDENCIESINTERN',
  //FIANCESINTERN: 'WSIFIANCESINTERN',
  //NIOSDISPONIBLESPROVINTERN: 'WSNIOSDISPONIBLESPROVINTERN',
  //REBUTSTRAMITACIODINSTERMINI: 'WSPASREBUTSTRAMDINSTERMSWSI',
  //REBUTSTRAMITACIOFORATERMINI: 'WSPASREBUTSTRAMFORATERMSWSI',
  //EMBARGOSTERCERO: 'WSGETEMBARGOS',
  //EMBARGOSTERCEROINTERN: 'WSGETEMBARGOSINTERN',
  //EXPEDIENTSAJUDABYNUMREGISTRE: 'WSPASEXPEDIENTSAJUDANUMREG',
  //EXPEDIENTSBYNUMREGISTRE: 'WSPASEXPEDIENTSNUMREG',
  NOTCOMVIGWSI : 'VRWSNOTCOMVIGWSI',
  REBUTSULTANYWSI : 'VRWSREBUTSULTANYWSI',
  PASFACTULTANYWSI : 'VRPASFACTULTANYWSI',
  PASEXPEDULTANYWSI: 'VRPASEXPEDULTANYWSI',
  ALTRESSERVEISCIUTADA: 'WSALTRESSERVEISCIUTADA',
  ALTRESSERVEISEMPRESA: 'WSALTRESSERVEISEMPRESA',
  ALTRESSERVEISPROVEIDOR: 'WSALTRESSERVEISPROVEIDOR',
  WSINFANTS3UNITATFAM: 'WSINFANTS3UNITATFAM',
  WSXESCOLESZONAPADRO: 'WSXESCOLESZONAPADRO',
  WSXINFANTS12UNITATFAM: 'WSXINFANTS12UNITATFAM',
  WSGETPERSONSBYIDNUMCTRDG: 'WSGETPERSONSBYIDNUMCTRDG',
  WSAVISOSHABITANTEPOB: 'WSAVISOSHABITANTEPOB',
  VRWSPASHABITADADESWSI: 'VRWSPASHABITADADESWSI',

  /** Web Services externos inventados para diferenciarlos del su clon */
  TRAMITVISTARAPIDA: "TRAMITVISTARAPIDA",
  ALTRESERVEISVISTARAPIDA: "ALTRESERVEISVISTARAPIDA"
}

/** código de las diferentes categorias de los web services externos */
export const CODE_SETVALUES = {
  GENERAL : 'WS-GENERAL',
  ECONOMY: 'WS-ECONOMY',
  PROCEDURE: 'WS-PROCEDURE',
  SERVICES: 'WS-SERVICES',
  COMUNICATIONS: 'WS-COMUNICATIONS',
  OTHERS: 'WS-OTHERS',
  FISCAL: 'WS-FISCAL',
  REGFACT: 'WS-REGFACT',
  LINKS: 'WS-LINKS',
  FISCAL_SITCRED: 'WS-FISCAL-SITCRED',
  REGIS: 'WS-REGIS',
  EXPEDIENTS: 'WS-EXPEDIENTS',
  ELECCIONS: 'WS-ELECCIONS'
}

/** código de las diferentes tipos de datos de los web services externos */
export const TIPO_DATO = {
  BLANK: 'BLANK',
  FI4_ADDRES: 'FI4-ADDRES',
  FI4_DNI: 'FI4-DNI',
  FI4_OID: 'FI4-OID',
  TS_DBOID: 'TS-DBOID',
  FI4DATA: 'FI4DATA',
  FI4IMPORT: 'FI4IMPORT',
  FI4PERCENT: 'FI4PERCENT',
  TXT_LEFT: 'TXT-LEFT',
  TXT_CENTER: 'TXT-CENTER',
  TXT_RIGHT: 'TXT-RIGHT',
  COMP_FACT_LINK: 'COMP_FACT_LINK',
  TRAM_CARP_LNIK: 'TRAM_CARP_LNIK',
  SAICLINK: 'SAICLINK',
  DOWNLOADDOCUMENTTYPE: 'DOWNLOADDOCUMENTTYPE',
  PAGOREBLINKTYPE: 'PAGOREBLINKTYPE',
  TXT_NUM_ND: 'TXT-NUM-ND',
  SAICLINKNOCORR: 'SAICLINKNOCORR',
  ENOTUM_LINK: 'ENOTUM_LINK',
  ENOTUM: 'ENOTUM',
  PAGOREBUTLINK: 'PAGOREBUTLINK',
  CANVICONTACTLINK: 'CANVICONTACTLINK',
  LINKSEUELECTRTYPE: 'LINKSEUELECTRTYPE',
  LINKTRAMITSSEULIST: 'LINKTRAMITSSEULIST',
  LKSEUVOLPADROTYPE: 'LKSEUVOLPADROTYPE',
  LKSEUACCPTREVOC: 'LKSEUACCPTREVOC',
  LKSEUESMENES: 'LKSEUESMENES',
  LKSEUREGFACT: 'LKSEUREGFACT',
  LKSEUQUEIXES: 'LKSEUQUEIXES',
  LKSEUDOMFISCAL: 'LKSEUDOMFISCAL',
  LKSEUDOMBANCPROV: 'LKSEUDOMBANCPROV',
  LKSEUDOMBANCTRIB: 'LKSEUDOMBANCTRIB',
  CONTACTAREALINKTYPE: 'CONTACTAREALINKTYPE',
  LKSEUTOTSTRAMITSTYPE: 'LKSEUTOTSTRAMITSTYPE',
  LINKREGTELPADROTYPE : 'LINKREGTELPADROTYPE',
  LINKENVIARPADROMAIL: 'LINKENVIARPADROMAIL',
  LKPAGOSGI2: 'LKPAGOSGI2',

  /** EXCLUSIVOS DE PRODUCCION **/
  LINKACCEDIR: 'LINKACCEDIR',
  LINKAESCOLPROX: 'LINKAESCOLPROX',
  LINKAMPA: 'LINKAMPA',
  LINKCENTRE: 'LINKCENTRE',
  LKABMCENSANIM: 'LKABMCENSANIM',
  LKCANCELCITAPREVIA: 'LKCANCELCITAPREVIA',
  LKNOVACITAPREVIA: 'LKNOVACITAPREVIA',
  LKSEUBAIXAACTITYPE: 'LKSEUBAIXAACTITYPE',
  LKSGI2NOVAINSCR: 'LKSGI2NOVAINSCR',
  LINKSEUFUE: 'LINKSEUFUE',
  LKSEUPVTESP: 'LKSEUPVTESP',
  LKSEUESMENA: 'LKSEUESMENA'

}

/*Codes de BASE DE DATOS INTRAPASARELA*/
export const CODE_TOKEN_EXTERNO = 'WSIJVACCESSTOKEN';
export const MENSAJE_EXTERNO_LOGIN = 'URL_WS_VAL_LOGIN_CARP';
export const MENSAJE_INICIO = 'INITIAL_PAGE_MSG';
export const ESTALVIA_TEMPS = 'ESTALVIA_TEMP';
export const DESHAB_INTERNA = 'DESHAB_INTERNA';
export const WARNING_ACCES_INTERNA = 'WARNING_ACCES_INTERNA';
export const DESHAB_EXTERNA = 'DESHAB_EXTERNA';
export const DESHAB_EXTERNA_DESC = 'DESHAB_EXTER_DESC';
export const OVT_GTT_LINK = 'OVT_GTT_LINK';
export const OVT_GTT_LINK_ENABLED = 'OVT_GTT_LINK_ENABLED';
export const XML_LINKS_EXTERNOS ='XML_LINKS_EXTERNOS';

/**Links parte externa */
export const LINKS_EXTERNAL = {
  INCIDENCIES : 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/27486',
  DOWNLOAD : 'https://serveistest.reus.cat/registre/jsps/redirectWSIdownloadDocFromCode.jsp?unicodeDocument=',

  /**Links externos a webs ayuntamiento reus y otras */
  REUS: 'http://www.reus.cat/',
  REUS_SEU: 'https://seu.reus.cat/seu/',
  REUS_TURISMO: 'http://www.reusturisme.cat/',
  REUS_CULTURA: 'http://capitalcultura.reus.cat/',
  REUS_REDES: 'http://www.reus.cat/ajuntament/lajuntament-les-xarxes-socials',
  REUS_CONTRATACION: 'https://contractaciopublica.gencat.cat/ecofin_pscp/AppJava/cap.pscp?reqCode=start&set-locale=ca_ES&pagingPage=0',
  REUS_IDCAT: 'http://www.idcat.cat/',
  REUS_AVISO: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/34668',
  REUS_AVISOS: 'https://seu.reus.cat/seu/carpetaCiutadana/perTemes',
  REUS_ACCESIBILIDAD: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/34770',
  REUS_PRIVACIDAD: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/34680',
  REUS_PRIVACIDAD_EAIA: 'https://www.reus.cat/politica-de-privacitat-EAIA',
  REUS_COOKIES: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/34663',
  REUS_INFO_RGPD: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/34673',
  REUS_LOCALIZ: 'https://www.google.es/maps/place/Ayuntamiento+de+Reus/@41.155362,1.1066533,17z/data=!3m1!4b1!4m5!3m4!1s0x12a1511d7bf7d1f5:0x2cc4a77b28089faa!8m2!3d41.155362!4d1.108842?hl=es',
  REUS_CORREO: 'mailto:ajuntament@reus.cat',
  REUS_SERVICIOS: 'https://serveis.reus.cat',
  REUS_INSTAGRAM: 'https://www.instagram.com/reus_cat/',
  REUS_TWITTER: 'https://x.com/reus_cat',
  REUS_FACEBOOK: 'https://www.facebook.com/reus.cat/',
  REUS_YOUTUBE: 'https://youtube.com/reuscatsessions',
  REUS_AYUDA: 'https://www.reus.cat/ajuntament/servei-dacompanyament-en-tramits-telematics',
  REUS_AYUDA_CAS: 'https://www.reus.cat/es/ajuntament/servei-dacompanyament-en-tramits-telematics',
  REUS_REQUISITOS: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/585',
  REUS_REQUISITOS_GUIA: 'https://serveis.reus.cat/manuals/RequisitsSeuElectronica_AjReus_ca.pdf',
  REUS_REQUISITOS_GUIA_ES: 'https://serveis.reus.cat/manuals/RequisitsSeuElectronica_AjReus_es.pdf',
  REUS_INCIENCIAS: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/27486',
  REUS_INFO: 'https://serveis.reus.cat/ng/0001/',
  REUS_TUTORIAL: 'https://www.youtube.com/watch?v=Qv6WHnpsxMU',
  REUS_TRAMITS: 'https://seu.reus.cat/seu/carpetaCiutadana/tramit/',
  REUS_TUTORIAL_PROV_CA: 'https://nuvol.reus.cat/s/g5cQHNPsm3itjDp?dir=undefined&openfile=183043587',
  REUS_TUTORIAL_PROV_ES: 'https://nuvol.reus.cat/s/g5cQHNPsm3itjDp?dir=undefined&openfile=214647052',
  REUS_TRAMIT_ACOMPA: 'https://www.reus.cat/ajuntament/servei-dacompanyament-en-tramits-telematics',
  REUS_INCIDENCIA: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/13351?lang=ca_ES',
  REUS_INCIDENCIA_CAS: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/13351?lang=es',
  REUS_MAPA_WEB: 'https://seu.reus.cat/seu/contingutPublic/mostrarContingut/34467'
}

export const CARGOS_VALIDOS = {
  PRESI: 'PRESIDENT/A',
  SECRE: 'SECRETARI/A'
}

/*Nombre y Valores posibles de etiquetas de los WS*/
export const ETIQUETAS = {
    NOMBRE : {
        carpnomestat: 'CARPNOMESTAT',
        categcodi:'CATEGCODI',
        datacreacio: 'DATACREACIO',
        desccurta :'DESCCURTA',
        descllarga: 'DESCLLARGA',
        descripcio:'DESCRIPCIO',
        desctramit: 'DESCTRAMIT',
        estat: 'ESTAT',
        estatvrfactura: 'ESTATVRFACTURA',
        importepte: 'IMPORTEPTE',
        importtotal: 'IMPORTTOTAL',
        numtramit: 'NUMTRAMIT',
        //numtramittelem: 'NUMTRAMITTELEM',
        numtramittelem: 'URL_TRAM_TELEMATIC',
        detTramit: 'DETALLTRAMIT',
        detall: 'DETALL',
        urlServei: 'ENCODEDURL',
        recimport: 'RECIMPORT',
        situacio:'SITUACIO',
        estat_calcul: 'ESTAT_CALCULAT',
        tipus: 'TIPUS',
        titol: 'TITOL',
        textcarpcat: 'TEXT_CARP_CA',
        textcarpesp: 'TEXT_CARP_ES',
        individual: 'GENVOLPADR',
        colectivo: 'GENVOLPADRCOLSD',
        descesborrany: 'DESCRIPCION',
        nomesborrany: 'NOM_FORMULARI',
        dataesborrany: 'DATA_CREACIO_TXT',
        paramslinkesbregtel: 'PARAMSLINKESBREGTEL'
    },
    VALORES : {
      REBUTS : {
        c: 'C',
        p: 'P',
        pv: 'PV',
        pe: 'PE',
        a: 'A'
      },
      REBUTSESTAT:{
        pvft: 'PVFT',
        pvdt: 'PVDT',
        pvte: 'PVTE',
        pe: 'PE',
        c: 'C',
        tr: 'TR',
        a: 'A'
      },
      FACTURES: {
        pagada: 'PAGADA',
        rebutjada: 'REBUTJADA',
        incidencia: 'INCIDENCIA',
        pendent: 'PENDENT'
      },
      EXPEDIENTS: {
        excucio: 'Execució',
        arxivat: 'Arxivat',
        tancat: 'Tancat',
        ajud: "AJUD",
        trib: "TRIB",
        satrans:"SATRANS",
        altr: "ALTR"
      },
      NOTIFIC: {
        n: 'N',
        c: 'C'
      },
      CONTACTE: {
        movil: 'Mòbil',
        fax: 'Fax',
        email: 'Email',
        telefono: "Telèfon"
      }
    }
}

/** ### CONSTANTES DE FUNCIONALIDAD ### */
/** Contexto de desarrollo con json locales como datos (valor de 'configuration' en environment.localjson) */
export const LOCALJSON = 'localjson';

/**Identificar por donde accedemos a la parte externa */
export const EXTERNAL_PAGES = {
  PAGES : {
    ciudadano : 'CIUT',
    empresa : 'EMPR',
    proveedor : 'PROV'
  }
}

/**Rol correspondiente según seleccionemos una de las opciones de entrada en la parte externa */
export const EXTERNAL_ROL = {
  PAGES : {
    ciudadano : 'FI4INTERNET',
    empresa : 'FI4EMPRESA',
    proveedor : 'FI4PROVEIDOR'
  }
}

/** Numero de filas de una tabla */
export const NUM_FILE_TABLE: any[] = [
  { value: 1, label: '01' },
  { value: 5, label: '05' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
]

export const NUM_FILE_TABLE_OPTIONS = {
  MOVIL : [
    { value: 1, label: '01' },
    { value: 5, label: '05' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
  ],
  TABLET : [
    { value: 1, label: '01' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: 40, label: '40' },
  ],
  PC : [
    { value: 1, label: '01' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
  ]
}


/** Numero de filas de una tabla */
export const FILE_TABLE_DEF = 10;
export const FILE_TABLE = {
  MOVIL: 5,
  TABLET: 10,
  PC: 20
}

/** Tipo de dato parameters */
export const TIPO_DATO_PARAM: any[] = [
  { value: null, label: ''},
  { value: 0, label: 'STRING' },
  { value: 1, label: 'NUMERIC' },
]

/** Tipo de dato parameters */
export const TIPO_DATO_FIELDTYPE: any[] = [
  { value: null, label: ''},
  { value: 0, label: 'STRING' },
  { value: 1, label: 'NUMERIC' },
  { value: 2, label: 'DATE TIME' },
  { value: 3, label: 'DATE TIME HOUR' },
]

/** Tipo de align */
export const ALIGN: any[] = [
  { value: null, label: ''},
  { value: 'left', label: 'LEFT' },
  { value: 'right', label: 'RIGHT' },
  { value: 'center', label: 'CENTER' },
]

/** Tipo de formato */
export const TIPO_FORMATO: any[] = [
  { value: null, label: ''},
  { value: 0, label: 'TEXT' },
  { value: 1, label: 'LINK' },
  { value: 2, label: 'DOWNLOAD' },
  { value: 3, label: 'CHECK' },
]

/** Opciones online */
export const ONLINE_OPTIONS: any[] = [
  { value: null, label: ''},
  { value: 0, label: 'OFFLINE' },
  { value: 1, label: 'ONLINE' },
  { value: 2, label: 'ONLINE INTERNAL' }
]

/** Opcion booleana */
export const BOOLEAN_OPTION: any[] = [
  { value: null, label: ''},
  { value: 0, label: 'NO' },
  { value: 1, label: 'SI' },
]

/** Opcion booleana */
export const VIEW_OPTION: any[] = [
  { value: null, label: ''},
  { value: 0, label: 'NO' },
  { value: 1, label: 'SI' },
  { value: 2, label: 'ALL' },
]

/** Opcion idioma */
export const LANG_OPTIONS: any[] = [
  //{ value: null, label: '' },
  { value: 'ca', label: 'CATALÀ' },
  { value: 'es', label: 'CASTELLÀ' },
]

/** Opcion iconos */
export const ICON_OPTIONS: any[] = [
  { value: '', label: '' },
  { value: 'zoom', label: 'ZOOM' },
  { value: 'down', label: 'DOWN' },
  { value: 'alarm', label: 'ALARM' },
  { value: 'bomb', label: 'BOMB' },
  { value: 'unlink', label: 'LINK' },
]


/** Codis de parámetros de BD tabla PARAMETRE */
export const PARAMETRES = {
  CLIENTID: "VALID.CLIENT_ID",
  COD_EMPRESA: "00001"
}

/** ### URLS DE PETICIONES AL SERVIDOR ### */
const isLocaljson = CONFIGURATION !== LOCALJSON;
const APPLICATIONDEFS = SERVER_API_URL + 'applicationdefs/';
const CAS = SERVER_API_URL + 'cas/';
const DBATTRS = SERVER_API_URL + 'dbattrs/';
const DBINDEXFLDS = SERVER_API_URL + 'dbindexflds/';
const DBINDICES = SERVER_API_URL + 'dbindices/';
const DBMODELS = SERVER_API_URL + 'dbmodels/';
const DEBUGS = SERVER_API_URL + 'debugs/';
const DEMO2DELETES = SERVER_API_URL + 'demo2deletes/';
const FIELDLINKS = SERVER_API_URL + 'fieldlinks/';
const FIELDTYPES = SERVER_API_URL + 'fieldtypes/';
const MENUITEMS = SERVER_API_URL + 'menuitems/';
const OPERATIONS = SERVER_API_URL + 'operations/';
const PARAMETERS = SERVER_API_URL + 'parameters/';
const PASLOGSESSIONS = SERVER_API_URL + 'paslogsessions/';
const PASSRVMENUITEMS = SERVER_API_URL + 'passrvmenuitems/';
const PERMISSIONS = SERVER_API_URL + 'permissions/';
const PROCEDUREDEFS = SERVER_API_URL + 'proceduredefs/';
const PROCEDURELOGS = SERVER_API_URL + 'procedurelogs/';
const ROLS = SERVER_API_URL + 'rols/';
const ROLSEXTERNAL = SERVER_API_URL + 'rolsexternal/';
const SETVALUES = SERVER_API_URL + 'setvalues/';
const TABLEDEFS = SERVER_API_URL + 'tabledefs/';
const TYPEFINDERS = SERVER_API_URL + 'typefinders/';
const TYPERUNS = SERVER_API_URL + 'typeruns/';
const USERS = SERVER_API_URL + 'users/';
const VERSIONCTLS = SERVER_API_URL + 'versionctls/';
const WSDEFS = SERVER_API_URL + 'wsdefs/';
const XMLDEFS = SERVER_API_URL + 'xmldefs/';
const XMLFIELDS = SERVER_API_URL + 'xmlfields/';
const LOGIN = SERVER_API_URL + 'auth/';
const VALID = SERVER_API_URL + 'valid/';
const PRUEBA = SERVER_API_URL + 'prueba/';
const WEBSERVICE = SERVER_API_URL + "webservice/";
const TEXTS = SERVER_API_URL + "texts/";
const NOTICES = SERVER_API_URL + "notices/";
const STATISTICS = SERVER_API_URL + "statistics/";
const STATISTICSEXTERNAL = SERVER_API_URL + "statisticsexternal/";
const COMMENTS = SERVER_API_URL + "comments/";
const COMMENTSINTERNA = SERVER_API_URL + "commentsinterna/";
const USERPROFILE = SERVER_API_URL + "userprofile/";
const AVIS = SERVER_API_URL + "avis/";
const TOKENSESSION = SERVER_API_URL + "tokensession/";

/**PARTE EXTERNA DATOS GENERALES**/
const ACCESTOTSTRAMITS = SERVER_API_URL + "accestotstramits/";
const PERSONSBYIDNUMCTRLDIG = SERVER_API_URL + "personsbyidnumctrldig/";

/** ### URLS DE PETICIONES AL SERVIDOR  CONEXION REGTEL### */
const CARPTIPUSAVISOS = SERVER_API_URL + "carptipusavisos/";
const CARPTIPUSCARPETA = SERVER_API_URL + "carptipuscarpeta/";
const CARPAVISOSTER = SERVER_API_URL + "carpavisoster/";
const APPLICATION = SERVER_API_URL + "application/";
const REPRESENTAACCLOG = SERVER_API_URL + "representaacclog/";
const REGTEL_PARAMETRE = SERVER_API_URL + "parametre/"

/**URL DEL LOGIN**/
const REFRESH = isLocaljson ? 'refresh' : '';
const ISLOGGED = isLocaljson ? 'isLogged' : '';

/** PARAMETROS PARA HACER FUNCIONAR LOS SERVICIOS DE LA OVT */
export const PARAMS_OVT = {
  SERVICIO: "AREUS",
  SUBORGANISMO: "431230",
  CLAVE: "#AREUS#",
  URL_BASE: "https://oficinavirtual.tributoslocales.es/",
  
}

export const ACCESO_EXTERNAL = {
  ciudadano: {
    type: 1,
    urlOK: "/external/valid?carpeta=1",
    urlKO: "/external/error?numError=1",
    urlCancel: "/external/passarela/acces",
    title: "CIUDADANO.ACCESO.title",
    content: "CIUDADANO.ACCESO.content",
    descripcion: "CIUDADANO.ACCESO.descripcion",
    textButton: "CIUDADANO.ACCESO.acceder",
    textButonAoc: "CIUDADANO.ACCESO.acceder_aoc",
    urlHome: "/external/passarela/home",
    rol: "FI4INTERNET"
  },
  empresa: {
    type: 2,
    urlOK: "/external/valid?carpeta=2",
    urlKO: "/external/error?numError=1",
    urlCancel: "/external/empreses/acces",
    title: "EMPRESA.ACCESO.title",
    content: "EMPRESA.ACCESO.content",
    descripcion: "EMPRESA.ACCESO.descripcion",
    textButton: "EMPRESA.ACCESO.acceder",
    textButonAoc: "EMPRESA.ACCESO.acceder_aoc",
    urlHome: "/external/empreses/home",
    rol: "FI4EMPRESA"
  },
  proveedor: {
    type: 3,
    urlOK: "/external/valid?carpeta=3",
    urlKO: "/external/error?numError=1",
    urlCancel: "/external/proveidors/acces",
    title: "PROVEEDOR.ACCESO.title",
    content: "PROVEEDOR.ACCESO.content",
    descripcion: "PROVEEDOR.ACCESO.descripcion",
    textButton: "PROVEEDOR.ACCESO.acceder",
    textButonAoc: "PROVEEDOR.ACCESO.acceder_aoc",
    urlHome: "/external/proveidors/home",
    rol: "FI4PROVEIDOR"
  }
}

export const PETICIONES = {
  regtel_parametre: {
    findByCodi: REGTEL_PARAMETRE
  },
  applicationdefs:{
    findAll: APPLICATIONDEFS,
    findById: APPLICATIONDEFS + 'getById',
    postApplicationdefs: APPLICATIONDEFS + 'postApplicationdefs',
    deleteApplicationdefs: APPLICATIONDEFS + 'deleteApplicationdefs'
  },
  cas:{
    findAll: CAS,
    findById: CAS + 'getById',
    postCas: CAS + 'postCas',
    deleteCas: CAS + 'deleteCas'
  },
  dbattrs:{
    findAll: DBATTRS,
    findById: DBATTRS + 'getById',
    postDbattrs: DBATTRS + 'postDbattrs',
    deleteDbattrs: DBATTRS + 'deleteDbattrs'
  },
  dbindexflds:{
    findAll: DBINDEXFLDS,
    findById: DBINDEXFLDS + 'getById',
    postDbindexflds: DBINDEXFLDS + 'postDbindexflds',
    deleteDbindexflds: DBINDEXFLDS + 'deleteDbindexflds'
  },
  dbindices:{
    findAll: DBINDICES,
    findById: DBINDICES + 'getById',
    postDbindices: DBINDICES + 'postDbindices',
    deleteDbindices: DBINDICES + 'deleteDbindices'
  },
  dbmodels:{
    findAll: DBMODELS,
    findById: DBMODELS + 'getById',
    postDbmodels: DBMODELS + 'postDbmodels',
    deleteDbmodels: DBMODELS + 'deleteDbmodels'
  },
  debugs:{
    findAll: DEBUGS,
    findById: DEBUGS + 'getById',
  },
  demo2deletes:{
    findAll: DEMO2DELETES,
    findById: DEMO2DELETES + 'getById',
  },
  fieldlinks:{
    findAll: FIELDLINKS,
    findById: FIELDLINKS + 'getById',
    postFieldlinks: FIELDLINKS + 'postFieldlinks',
    deleteFieldlinks: FIELDLINKS + 'deleteFieldlinks',
  },
  fieldtypes:{
    findAll: FIELDTYPES,
    findById: FIELDTYPES + 'getById',
    postFieldtypes: FIELDTYPES + 'postFieldtypes',
    deleteFieldtypes: FIELDTYPES + 'deleteFieldtypes',
  },
  menuitems:{
    findAll: MENUITEMS,
    findById: MENUITEMS + 'getById',
    postMenuitems: MENUITEMS + 'postMenuitems',
  },
  operations:{
    findAll: OPERATIONS,
    findById: OPERATIONS + 'getById',
  },
  parameters:{
    findAll: PARAMETERS,
    findById: PARAMETERS + 'getById',
    findByCode: PARAMETERS + 'getByCode',
    postParameters: PARAMETERS + 'postParameters',
    deleteParameters: PARAMETERS + 'deleteParameters',
  },
  paslogsessions:{
    findAll: PASLOGSESSIONS,
    findById: PASLOGSESSIONS + 'getById',
    postPaslogsessions: PASLOGSESSIONS + 'postPaslogsessions',
  },
  passrvmenuitems:{
    findAll: PASSRVMENUITEMS,
    findById: PASSRVMENUITEMS + 'getById',
    postPassrvmenuitems: PASSRVMENUITEMS + 'postPassrvmenuitems',
  },
  permissions:{
    findAll: PERMISSIONS,
    findById: PERMISSIONS + 'getById',
    postPermissions: PERMISSIONS + 'postPermissions',
    deletePermissions: PERMISSIONS + 'deletePermissions',
    deleteAllPermissions: PERMISSIONS + 'getDeletePermissions',
  },
  proceduredefs:{
    findAll: PROCEDUREDEFS,
    findById: PROCEDUREDEFS + 'getById',
    postProceduredefs: PROCEDUREDEFS + 'postProceduredefs',
  },
  procedurelogs:{
    findAll: PROCEDURELOGS,
    findById: PROCEDURELOGS + 'getById',
    postProcedurelogs: PROCEDURELOGS + 'postProcedurelogs',
  },
  prueba: PRUEBA + "getPrueba",
  rols:{
    findAll: ROLS,
    findById: ROLS + 'getById',
    findByCode: ROLS + 'getByCode',
    postRolsInternal: ROLS + 'postRolsInternal',
    deleteRolsInternal: ROLS + 'deleteRolsInternal',
  },
  rolsexternal:{
    findAll: ROLSEXTERNAL,
    findByCode: ROLSEXTERNAL + 'getByCode',
    postRolsExternal: ROLSEXTERNAL + 'postRolsExternal',
    deleteRolsExternal: ROLSEXTERNAL + 'deleteRolsExternal',
  },
  setvalues:{
    findAll: SETVALUES,
    findById: SETVALUES + 'getById',
    postSetvalues: SETVALUES + 'postSetvalues',
    deleteSetvalues: SETVALUES + 'deleteSetvalues',
  },
  tabledefs:{
    findAll: TABLEDEFS,
    findById: TABLEDEFS + 'getById',
    postTabledefs: TABLEDEFS + 'postTabledefs',
  },
  typefinders:{
    findAll: TYPEFINDERS,
    findById: TYPEFINDERS + 'getById',
    postTypefinders: TYPEFINDERS + 'postTypefinders',
    deleteTypefinders: TYPEFINDERS + 'deleteTypefinders',
  },
  typeruns:{
    findAll: TYPERUNS,
    findById: TYPERUNS + 'getById',
    postTyperuns: TYPERUNS + 'postTyperuns',
    deleteTyperuns: TYPERUNS + 'deleteTyperuns',
  },
  users: {
    findAll: USERS + 'getUsers',
    findById: USERS + 'getById',
    findByLogin: USERS + 'getByLogin',
    postUsers: USERS + 'postUsers',
    login: USERS + 'getLogin',
  },
  versionctls:{
    findAll: VERSIONCTLS,
    findById: VERSIONCTLS + 'getById',
    postVersionctls: VERSIONCTLS + 'postVersionctls',
  },
  wsdefs:{
    findAll: WSDEFS,
    findBySetvalue: WSDEFS + 'getBySetvalue/',
    findById: WSDEFS + 'getById',
    postWsdefs: WSDEFS + 'postWsdefs',
    deleteWsdefs: WSDEFS + 'deleteWsdefs',
  },
  xmldefs:{
    findAll: XMLDEFS,
    findById: XMLDEFS + 'getById',
    postXmldefs: XMLDEFS + 'postXmldefs',
    deleteXmldefs: XMLDEFS + 'deleteXmldefs',
  },
  xmlfields:{
    findAll: XMLFIELDS,
    findById: XMLFIELDS + 'getById',
    findByXmldefId: XMLFIELDS + 'getByXmldefId',
    postXmlfields: XMLFIELDS + 'postXmlfields',
    deleteXmlfields: XMLFIELDS + 'deleteXmlfields',
  },
  login: {
    login: LOGIN + 'login',
    refresh:  LOGIN + REFRESH,
    isLogged: LOGIN + ISLOGGED,
  },
  valid: {
    url: VALID + 'urlValid',
    uniqueId: VALID + 'uniqueId',
    urlAuth: VALID + 'urlAuth/',
    token: VALID + 'login/',
    logout: VALID + 'logout/',
    revoke: VALID + 'revoke/'
  },
  texts:{
    findAll: TEXTS,
    findById: TEXTS + 'getById',
    findByCode: TEXTS + 'getByCode',
    postTexts: TEXTS + 'postTexts',
    deleteTexts: TEXTS + 'deleteTexts',
  },
  notices:{
    findAll: NOTICES,
    findById: NOTICES + 'getById',
    findByCode: NOTICES + 'getByCode',
    postNotices: NOTICES + 'postNotices',
    deleteNotices: NOTICES + 'deleteNotices',
  },
  statistics:{
    findAll: STATISTICS,
    findById: STATISTICS + 'getById',
    postStatistics: STATISTICS + 'postStatistics',
    postStatisticsSesion: STATISTICS + 'postStatisticsSesion',
    postStatisticsFiltro: STATISTICS + 'postStatisticsFiltro',
    deleteStatistics: STATISTICS + 'deleteStatistics',
  },
  statisticsexternal:{
    findAll: STATISTICSEXTERNAL,
    findById: STATISTICSEXTERNAL + 'getById',
    postStatisticsExternal: STATISTICSEXTERNAL + 'postStatisticsExternal',
    postStatisticsExternalSesion: STATISTICSEXTERNAL + 'postStatisticsExternalSesion',
    postStatisticsExternalFiltro: STATISTICSEXTERNAL + 'postStatisticsExternalFiltro',
    deleteStatisticsExternal: STATISTICSEXTERNAL + 'deleteStatisticsExternal',
  },
  comments:{
    findAll: COMMENTS,
    findById: COMMENTS + 'getById',
    findByDboid: COMMENTS + 'getByDboid',
    findByUsers: COMMENTS + 'getByUsers',
    findByUsername: COMMENTS + 'getByUsername',
    findByUserNif: COMMENTS + 'getByUserNif',
    postComments: COMMENTS + 'postComments',
    deleteComments: COMMENTS + 'deleteComments',
  },
  commentsinterna:{
    findAll: COMMENTSINTERNA,
    findById: COMMENTSINTERNA + 'getById',
    findByDboid: COMMENTSINTERNA + 'getByDboid',
    postCommentsInterna: COMMENTSINTERNA + 'postCommentsInterna',
    deleteCommentsInterna: COMMENTSINTERNA + 'deleteCommentsInterna',
  },
  avis:{
    findAll: AVIS,
    findById: AVIS + 'getById',
    findByDboid: AVIS + 'getByDboid',
    postAvis: AVIS + 'postAvis',
    postAvRead: AVIS + 'postAvRead',
    deleteAvis: AVIS + 'deleteAvis',
  },
  userprofile:{
    findAll: USERPROFILE,
    findById: USERPROFILE + 'getById',
    findByIdentifier: USERPROFILE + 'getByIdentifier',
    postUserprofile: USERPROFILE + 'postUserprofile',
    deleteUserprofile: USERPROFILE + 'deleteUserprofile',
  },
  accesTotsTramits: {
    findAll:   ACCESTOTSTRAMITS + "getAccesTotsTramits",
    buscaAllTramits: ACCESTOTSTRAMITS + "getBuscaTotsTramits",
  },
  personsByIdNumCtrlDig: {
    findAll:   PERSONSBYIDNUMCTRLDIG + "getPersonsByIdNumCtrlDig",
  },
  tokensession:{
    findAll: TOKENSESSION,
    findByUserid: TOKENSESSION + 'getByUserid',
    postTokensession: TOKENSESSION + 'postTokensession',
    deleteTokensession: TOKENSESSION + 'deleteTokensession',
  },
  webservice: {
    doPost: WEBSERVICE + "getDoPost",
    doGet: WEBSERVICE + "getDoGet",
    doGetLogin: WEBSERVICE + "getDoGetLogin",
    doGetActividad: WEBSERVICE + "getDoActividad",
    doGetRepresentants: WEBSERVICE + "getDoRepresentants",
    doGetProveidors: WEBSERVICE + "getDoProveidors",
    doGetLastValoracio: WEBSERVICE + "getDoLastValoracio",
    dogetIpAdress: WEBSERVICE + "getDoIpAdress",
    doGetRepresentanteAOC: WEBSERVICE + "doGetRepresentanteAOC",
    doGetRepresentadoAOC: WEBSERVICE + "doGetRepresentadoAOC",
    doGetRepresentaProveidors:  WEBSERVICE + "doGetRepresentaProveidors",
    doGetRepresentaEmpresas:  WEBSERVICE + "doGetRepresentaEmpresas",
    doPostMail: WEBSERVICE + "getDoPostMail",
    doPostArchivo: WEBSERVICE + "doPostArchivo",
  },
   /**PETICIONES REGTEL **/
  carpTipusAvisos: {
    findAll: CARPTIPUSAVISOS,
  },
  carpTipusCarpeta: {
    findAll: CARPTIPUSCARPETA,
  }
  ,
  carpAvisosTer: {
    findAll: CARPAVISOSTER,
    postCarpAvisosTer: CARPAVISOSTER + 'postCarpAvisosTer',
    getByIdentifTer : CARPAVISOSTER + 'getByIdentifTer',
  },
  application: {
    findAll: APPLICATION,
    postApplication: APPLICATION + 'postApplication',
  },
  representaAccLog: {
    findAll: REPRESENTAACCLOG,
    postRepresentaAccLog: REPRESENTAACCLOG + 'postRepresentaAccLog',
    postRepresentaAccLogSecuencia: REPRESENTAACCLOG + 'postRepresentaAccLogSecuencia',
  }
}

const VALID_URL = environment.valid_url;
export const VALID_URLS = {
  GETUNIQID: VALID_URL + "getUniqId/",
  AUTHENTICATIONPROCESS: VALID_URL + "signatureValid/authenticationProcess?id=",
  LOGIN: VALID_URL + "signatureValid/loginProcess",
  GETACCESTOKEN: VALID_URL + "signatureValidApplet/getAccessToken",
  SIGNPROCESS: VALID_URL + "signatureValidApplet/SignProcess",
  SIGNATUREVALIDAPPLET: VALID_URL + "signatureValidApplet/redirect/?token_id=",
  GETAUTHENTICATIONTOKEN: VALID_URL + "signatureValid/getAuthenticationToken?id=",
  GETAUTHENTICATIONTOKENS: VALID_URL + "signatureValid/getAuthenticationTokenS?id=",
  BASICSIGNATURE: VALID_URL + "signatureValid/basicSignature/",
  GETAUTHENTICATIONEVIDENCE: VALID_URL + "signatureValid/getAuthenticationEvidence/?token=",
  LOGOUT: VALID_URL + "signatureValid/logout/?token="
};
